import { combineReducers } from 'redux';
import user from './user.reducer';
import auth from './auth.reducer';

const authReducers = combineReducers({
	user,
	auth
});

export default authReducers;
